import React from 'react';
import { observer } from 'mobx-react';
import { FooterTemplate } from 'themes/components';
import { useStores } from 'core/stores/StoreContext';

const Footer = observer((props) => {
    const { routerStore, menuStore } = useStores();
    return <FooterTemplate {...props} routerStore={routerStore} menuStore={menuStore} />;
});

export default Footer;
